export default "__VITE_ASSET__423ad88e__"